import FlavourConfig from '../config/flavours';

const PILOT_HINT_KEY = 'pilot_hint';
const TRACK_SETTINGS_KEY = 'track_settings';

const Storage = {
  get: (key: string) => {
    return localStorage.getItem(`${FlavourConfig.appName}_${key}`);
  },
  set: (key: string, value: string) => {
    localStorage.setItem(`${FlavourConfig.appName}_${key}`, value);
  },
  delete: (key: string) => {
    localStorage.removeItem(`${FlavourConfig.appName}_${key}`);
  },
};

export { PILOT_HINT_KEY, TRACK_SETTINGS_KEY };
export default Storage;
